function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === 'function') {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { endOfMonth, getLocalTimeZone, getWeeksInMonth, startOfWeek, today } from "@internationalized/date";
import { cloneElement, useMemo } from "react";
import { useCalendarGrid, useLocale } from "react-aria";
import CalendarCell from "./CalendarCell";
import getWeekOfMonth from "./getWeekOfMonth";
const CalendarMonth = (props)=>{
    const { state , startDate , variant , thead  } = props;
    const endDate = endOfMonth(startDate);
    const { locale  } = useLocale();
    const { gridProps , headerProps  } = useCalendarGrid({
        startDate,
        endDate
    }, state);
    const weeksInMonth = useMemo(()=>{
        const timezone = getLocalTimeZone();
        const todayDate = today(timezone);
        // Calculate the first day of the week that the calendar will use
        const weekStart = startOfWeek(today(timezone), locale);
        const day = new Date(weekStart.year, weekStart.month - 1, weekStart.day);
        // TODO: this is super-inefficient - we just want `firstDayOfWeek` to be
        // 0 if the week starts on Sunday or 1 if the week starts on Monday.
        const firstDayOfWeek = day.getDay();
        if (variant === "scheduler") {
            const weekOfMonth = getWeekOfMonth(todayDate.toDate(timezone), firstDayOfWeek);
            return Array.from(new Array(5), (_, index)=>{
                return weekOfMonth + index;
            });
        }
        if (variant === "infinite") {
            if (todayDate.month === startDate.month && todayDate.year === startDate.year) {
                const start = getWeekOfMonth(todayDate.toDate(timezone), firstDayOfWeek);
                const end = getWeekOfMonth(endDate.toDate(timezone), firstDayOfWeek);
                const step = 1;
                return Array.from({
                    length: (end - start) / step + 1
                }, (_, i)=>start + i * step);
            }
        }
        return [
            ...new Array(getWeeksInMonth(startDate, locale)).keys()
        ];
    }, [
        endDate,
        locale,
        startDate,
        variant
    ]);
    const monthStart = startOfWeek(startDate, locale);
    return /*#__PURE__*/ _jsxs("table", _objectSpread({}, gridProps, {
        children: [
            thead && /*#__PURE__*/ cloneElement(thead, headerProps),
            /*#__PURE__*/ _jsx("tbody", {
                children: weeksInMonth.map((weekIndex)=>/*#__PURE__*/ _jsx("tr", {
                        children: [
                            ...new Array(7).keys()
                        ].map((dayIndex)=>/*#__PURE__*/ _jsx(CalendarCell, {
                                locale: locale,
                                state: state,
                                scheduler: variant === "scheduler",
                                date: monthStart.add({
                                    weeks: weekIndex,
                                    days: dayIndex
                                }),
                                currentMonth: variant === "infinite" ? startDate : undefined
                            }, dayIndex))
                    }, weekIndex))
            })
        ]
    }));
};
export default CalendarMonth;
